import request from "utils/request";

export async function cloudBlogPreview(payload) {
	return request("/rest/cloud_blog_preview", {
		method: "POST",
		body: payload
	});
}